/**
 * 共通受付照会API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 電気契約情報
 */
export interface Sgkb575aResElecCtrInfo {
    /** 
     * 送配電事業者コード：半角英数混在
     */
    transCode?: string;
    /** 
     * 送配電事業者コード名称：全角半角混在
     */
    transCodeAname?: string;
    /** 
     * 電圧区分：半角英数混在
     */
    voltDiv?: string;
    /** 
     * 電圧区分名称：全角半角混在
     */
    voltDivAname?: string;
    /** 
     * 申込種別：半角英数混在
     */
    srnClsfy?: string;
    /** 
     * 申込種別名称：全角半角混在
     */
    srnClsfyAname?: string;
    /** 
     * 供給地点特定番号：半角英数混在
     */
    suppntSpno?: string;
    /** 
     * 廃止理由区分コード：半角英数混在
     */
    ablitnRsncod?: string;
    /** 
     * 廃止理由区分コード名称：全角半角混在
     */
    ablitnRsncodAname?: string;
    /** 
     * 建物解体有無フラグ：半角英数混在
     */
    dmntrdEonflg?: string;
    /** 
     * 建物解体有無フラグ名称：全角半角混在
     */
    dmntrdEonflgAname?: string;
    /** 
     * 建物解体予定日付：日付YYYYMMDD
     */
    dmntrdScdDate?: string;
    /** 
     * 建物解体予定時刻：半角英数混在
     */
    dmntrdStimez?: string;
    /** 
     * 建物解体予定時刻名称：全角半角混在
     */
    dmntrdStimezAname?: string;
    /** 
     * 現小売事業者コード：半角英数混在
     */
    oldretCode?: string;
    /** 
     * 現小売事業者コード名称：全角半角混在
     */
    oldretAname?: string;
    /** 
     * 廃止取次番号：半角数字
     */
    ablcomNo?: string;
    /** 
     * 現小売事業者契約番号：半角英数混在
     */
    oldretCtrNo?: string;
    /** 
     * 検針日選択区分：半角英数混在
     */
    ksdateSentakuDiv?: string;
    /** 
     * 検針日選択区分名称：全角半角混在
     */
    ksdateSentakudivAname?: string;
    /** 
     * 設備情報契約決定方法：半角英数混在
     */
    equipmentinformationContractdecisionway?: string;
    /** 
     * 設備情報契約決定方法名称：全角半角混在
     */
    equipmentinformationContractdecisionwayAname?: string;
    /** 
     * 契約決定方法コード：半角英数混在
     */
    ctrdcsCode?: string;
    /** 
     * 契約決定方法コード名称：全角半角混在
     */
    ctrdcsCodeAname?: string;
    /** 
     * スイッチング支援システム連係有無フラグ：半角英数混在
     */
    swshienLinkEonflg?: string;
    /** 
     * スイッチング支援システム連係有無フラグ名称：全角半角混在
     */
    swshiensystemLinkumuFlganame?: string;
    /** 
     * 廃止取次有無フラグ：半角英数混在
     */
    ablcomFlg?: string;
    /** 
     * 廃止取次有無フラグ名称：全角半角混在
     */
    ablcomEonflgAname?: string;
    /** 
     * 電気契約有無変更処理ステータス：半角英数混在
     */
    electricitycontractUmuchangeTransactionstatus?: string;
    /** 
     * 電気契約有無変更処理ステータス名称：全角半角混在
     */
    electricitycontractUmuchangeTransactionstatusAname?: string;
    /** 
     * 関連会社区分：半角英数混在
     */
    relatedcompanyDiv?: string;
    /** 
     * 関連会社区分名称：全角半角混在
     */
    relatedCompanyDivaname?: string;
    /** 
     * 関連会社お客さま番号：半角数字
     */
    relatedcompanyVisitornumber?: string;
}
